define('modules/home/main/views/home.header.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "bootstrap",
    'modules/home/main/views/history.view',
    "text!modules/home/main/templates/home.header.template.html"
], function(Prospector, $,_,Backbone,
            Marionette,
            Bootstrap,
            HistoryView,
            Template
    ) {
    var HomeHeaderView = Marionette.LayoutView.extend({
        template: _.template(Template),
        className: 'col-xs-12',
        events:{
            "click .logout": "logout",
            "click .openHistory" : "openHistory"
        },
        regions: {
            subMenu: ".subMenu",
            topDrawer: ".topRow div.col-lg-12"
        },
        isFirstLoad: true,
        queue: 0,
        isTrialMenu: false,
        initialize:function(){
            $('.navbar-nav').show();
            Prospector.subMenuApp = undefined;
            Prospector.topDrawerApp = undefined;
            Prospector.on("closeHistoryDrawer", this.closeHistoryDrawer, this);
            Prospector.on("fillSubMenu", this.fillSubMenu, this);
            Prospector.on("emptySubMenu", this.emptySubMenu, this);
            Prospector.on("emptyTopDrawer", this.emptyTopDrawer, this);
            Prospector.on("fillTopDrawer", this.fillTopDrawer, this);
            Prospector.on("openTopDrawer", this.openTopDrawer, this);
            Prospector.on("closeTopDrawer", this.closeTopDrawer, this);
            this.listenTo(Prospector, "showTrialSubMenu", this.showTrialSubMenu, this);
        },
        onClick:function(){
            Backbone.history.navigate('/', true);
        },
        onRender:function(){
            if (window.session.get('status') == 100){
                if(window.user.has('id')){
                    this.buildMenu();
                }else{
                    window.user.once('sync', this.buildMenu, this);
                    window.user.fetch();
                }
            } else {
                this.$('.navbar-nav').hide();
            }
        },
        logout:function(){
            // delete $.ajaxSettings.headers["Authorization"];
            if(window.utils.isChromeExt()){
                this.logoutHead(window.utils.CHROME_CLIENT_ID);
            }else{
                this.logoutHead(window.utils.MOBILE_CLIENT_ID_PROD);
            }
            window.utils.clearSessionStorage();
            window.utils.clearStorage(function(){
                window.redirectUrl = Prospector.getCurrentRoute();
                Prospector.trigger("init");
                Prospector.navigate('login');
                window.location.reload();
            });
        },
        logoutHead: function(clientId){
            $.ajaxSetup({
                headers: {
                    'Authorization': '',
                    'client_id': clientId
                }
            });
        },
        buildMenu:function(){
            $('#mainMenu').show();
            this.$('.acctName').html(window.user.get('firstName')+'&nbsp;'+window.user.get('lastName')+'&nbsp;');
            /*if(window.contract.checkIsValid()){
                this.buildHistory();
            } else {
                this.$('.openHistory').remove();
            }*/
        },
        buildHistory:function(){
            var hv = new HistoryView();
            $('#rightbar-wrapper').append(hv.render().el);
        },
        openHistory:function(e){
            e.preventDefault();
            if(this.$(".openHistory").hasClass("active")){
                this.closeHistoryDrawer();
            } else {
                this.openHistoryDrawer();
            }
        },
        closeHistoryDrawer:function(options){
            if(this.$(".openHistory").hasClass("active")){
                this.$(".openHistory").removeClass("active");
                $("#wrapper").removeClass("history");
            }
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        },
        openHistoryDrawer:function(options){
            var that = this;
            Prospector.trigger('closeSideDrawer', {passedFunc: function(){
                if(!that.$(".openHistory").hasClass("active")){
                    that.$(".openHistory").addClass("active");
                    $("#wrapper").addClass("history");
                }
            }});
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        },
        emptySubMenu:function(){
            if(Prospector.subMenuApp != undefined){
                Prospector.subMenuApp.unbind();
                Prospector.subMenuApp.remove();
            }
            this.subMenu.empty();
            this.isTrialMenu = false;
        },
        fillSubMenu:function(options){
            this.emptySubMenu();
            Prospector.subMenuApp = options.view;
            this.subMenu.show(Prospector.subMenuApp);
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        },
        /*showTrialSubMenu:function(){
            if (window.contract.isTrial()) {
                if(!this.isTrialMenu){
                    this.emptySubMenu();
                    Prospector.subMenuApp = new TrialSubMenuView({parent: this});
                    this.subMenu.show(Prospector.subMenuApp);
                    this.isTrialMenu = true;
                }
            } else {
                Prospector.trigger("emptySubMenu");
            }
        },*/
        emptyTopDrawer:function(){
            if(Prospector.topDrawerApp != undefined){
                if(Prospector.topDrawerApp.destroy != undefined){
                    Prospector.topDrawerApp.destroy();
                }
                Prospector.topDrawerApp.unbind();
                Prospector.topDrawerApp.remove();
            }
            $('.topRow div.col-lg-12').empty();
        },
        fillTopDrawer:function(options){
            this.emptyTopDrawer();
            Prospector.topDrawerApp = options.view;
            $('.topRow div.col-lg-12').append(Prospector.topDrawerApp.render().el);
        },
        openTopDrawer:function(options){
            $('#page-content-wrapper').addClass('openTop');
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        },
        closeTopDrawer:function(options){
            var destroySubView = true;
            if(options != undefined && options.destroySubView != undefined){
                destroySubView = options.destroySubView;
            }
            if(destroySubView){
                this.emptyTopDrawer();
            }
            $('#page-content-wrapper').removeClass('openTop');
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        }
    });
    return HomeHeaderView;
});
